import { connect } from "react-redux";

import getPlanCovers from "../../../../store/plan/actions/getPlanCovers";
import setPlanCover from "../../../../store/plan/actions/setPlanCover";
import { post } from "../../../../actions/general";
import { IStateTree } from "../../../../store/interfaces";
import { IUser } from "../../../../store/user/models";

import Image from "./Image";

const mapStateToProps = ({ user }: IStateTree) => ({
    user: user as IUser,
});

export default connect(mapStateToProps, { getPlanCovers, setPlanCover, post })(Image);
